import { useEffect, useState } from "react";
import type { QuerySuccessResult } from "./QuerySuccessResult";
import { QueryResultView } from "./QueryResultView";
import styled from "styled-components";
import { useMutation } from "./useMutation";
import type { MutationProps } from "./MutationProps";
import { Button } from "@blueprintjs/core";
import { AdminPre } from "../shared/AdminPre";

const MutationWrapper = styled.div`
  border: 1px solid grey;
`;

const MutationTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  button {
    margin-left: 1em;
  }
`;

export function Mutation<TBody, TResult>({
  path,
  method,
  body,
  title,
  disabled,
  children,
}: MutationProps<TBody, TResult>) {
  const [sent, setSent] = useState<Date | undefined>();
  const { result, fetch } = useMutation<TBody, TResult>({ path, method, body });

  useEffect(() => {
    if (sent) fetch();
  }, [sent, fetch]);

  return (
    <MutationWrapper>
      <MutationTitle>
        <h3>{title}</h3>
        <Button
          type="button"
          disabled={disabled}
          onClick={() => {
            setSent(new Date());
            return fetch();
          }}
        >
          Send
        </Button>
      </MutationTitle>
      {sent ? (
        <QueryResultView<TResult> queryPage={result}>
          {() =>
            children ? (
              children(result as QuerySuccessResult<TResult>)
            ) : (
              <AdminPre>
                <code>{JSON.stringify(result.data, null, "  ")}</code>
              </AdminPre>
            )
          }
        </QueryResultView>
      ) : null}
    </MutationWrapper>
  );
}
